// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { Pressable, StyleSheet } from 'react-native';

import { Text, View } from '@/components/Themed';

type AuthStatusCardProps = {
  title: string;
  status?: string | null;
  error?: string | null;
  buttonLabel?: string;
  onPress?: () => void;
  disabled?: boolean;
  children?: React.ReactNode;
};

export const AuthStatusCard = ({ title, status, error, buttonLabel, onPress, disabled, children }: AuthStatusCardProps) => {
  return (
    <View style={styles.card}>
      <Text style={styles.title}>{title}</Text>
      {children}
      {status ? <Text style={styles.status}>{status}</Text> : null}
      {error ? <Text style={styles.error}>{error}</Text> : null}
      {buttonLabel && onPress ? (
        <Pressable style={[styles.button, disabled ? styles.buttonDisabled : null]} onPress={onPress} disabled={disabled}>
          <Text style={styles.buttonText}>{buttonLabel}</Text>
        </Pressable>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    backgroundColor: '#0f1c3c',
    borderRadius: 16,
    padding: 18,
    gap: 12,
    borderWidth: 1,
    borderColor: '#24346b',
  },
  title: {
    fontSize: 20,
    fontWeight: '700',
    color: '#f8fafc',
  },
  status: {
    color: '#a7f3d0',
  },
  error: {
    color: '#ff7b7b',
  },
  button: {
    marginTop: 8,
    backgroundColor: '#34d399',
    paddingVertical: 12,
    borderRadius: 12,
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#1aa374',
  },
  buttonDisabled: {
    opacity: 0.6,
  },
  buttonText: {
    color: '#0c1328',
    fontWeight: '800',
    fontSize: 16,
  },
});
